import { render, staticRenderFns } from "./mpHref.vue?vue&type=template&id=00975657&scoped=true&"
import script from "./mpHref.vue?vue&type=script&lang=js&"
export * from "./mpHref.vue?vue&type=script&lang=js&"
import style0 from "./mpHref.vue?vue&type=style&index=0&id=00975657&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00975657",
  null
  
)

component.options.__file = "mpHref.vue"
export default component.exports